/**
 * @module constants/Login
 */

export const LoginKeys = Object.freeze({
  IS_ANONYMOUS: 'isAnonymous',
  IS_LOGGED_IN_KEY: 'isLoggedIn',
  IS_LOGGING_IN_KEY: 'isLoggingIn',
  HAS_LOGGED_IN: 'hasLoggedIn',
  JUST_MIGRATED_WINDOWS_ACCOUNT: 'justMigratedWindowsAccount',
  USERNAME: 'username',
  LOGIN_ERROR_KEY: 'loginError',
  LOGIN_AUTH_TOKEN: 'loginAuthToken',
  LOGIN_REMEMBER_ME_KEY: 'loginRememberMe',
  LOGIN_FLOW_COMPLETE_KEY: 'isLoginFlowComplete',
  LOGIN_REDIRECT_ON_SUCCESS_KEY: 'loginRedirectOnSuccessLocation',
  LOGIN_FAIL_COUNT: 'loginFailCount',
  LOGIN_HAS_SEEN_NEW_USER_EDUCATION_KEY: 'loginHasSeenNewUserEducation',
  LOGIN_USER_INITIATED: 'loginUserInitiated',
  STASHED_EXISTING_AUTH_TOKEN: 'stashedExistingAuthToken',
  REGISTRATION_ERROR_CODE_KEY: 'registrationErrorCode',

  HAS_EMAILED_PASSWORD_RESET: 'HAS_EMAILED_PASSWORD_RESET',
  DEFAULT_RESET_PASSWORD_USERNAME: 'DEFAULT_RESET_PASSWORD_USERNAME',
  EMAIL_PASSWORD_USERNAME: 'EMAIL_PASSWORD_USERNAME',

  RESET_TOKEN_INVALID: 'RESET_TOKEN_INVALID',
  USER_TO_RESET_PASSWORD: 'USER_TO_RESET_PASSWORD',
  RESET_PASSWORD_API_ERROR: 'RESET_PASSWORD_API_ERROR',
  PREVIOUS_USERNAME: 'PREVIOUS_USERNAME',
} as const);

/**
 * The exposed, namespaced App related actions.
 */
export const LoginActions = Object.freeze({
  AUTHENTICATE_LISTENER: 'AUTHENTICATE_LISTENER',
  LOGIN_FLOW_COMPLETE: 'LOGIN_FLOW_COMPLETE',
  LOGIN_REDIRECT_ON_SUCCESS: 'LOGIN_REDIRECT_ON_SUCCESS',
  LOGIN_REMEMBER: 'LOGIN_REMEMBER',
  LOGIN_RESET: 'LOGIN_RESET',
  LOGOUT: 'LOGOUT',
  REGISTER: 'REGISTER',
  RESET_EMAIL_PASSWORD_SUCCESS: 'RESET_EMAIL_PASSWORD_SUCCESS',
  RESET_LISTENER_PASSWORD: 'RESET_LISTENER_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  SERVER_SIDE_AUTHENTICATED_LISTENER: 'SERVER_SIDE_AUTHENTICATED_LISTENER',
  SET_AUTH_TOKEN_NULL: 'SET_AUTH_TOKEN_NULL',
  SET_GENDER: 'SET_GENDER',
  SET_STASHED_EXISTING_AUTH_TOKEN: 'SET_STASHED_EXISTING_AUTH_TOKEN',
  SET_RESET_USERNAME: 'SET_RESET_USERNAME',
} as const);

export default LoginActions;
